import { ActivatedRoute, Router } from '@angular/router';
import { ProductService } from '../../services/product/product.service';
import { ToastrService } from 'ngx-toastr';
import { fadeAnimation } from '../../animations/animations';
import { PdvService } from '../../services/pdv/pdv.service';
import { OrdersService } from '../../services/order/orders.service';
import { MenuService } from '../../services/menu/menu.service';
import { FamilyService } from '../../services/family/family.service';
import { Component, ChangeDetectorRef, ViewChild, ElementRef, HostListener, Input } from '@angular/core';
import { Subscription, forkJoin, fromEvent, of } from 'rxjs';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PersonalizeProductComponent } from '@app/modules/modals/personalize-product/personalize-product.component';
import { MenuModalComponent } from '@app/modules/modals/menu-modal/menu-modal.component';
import { isPlatformBrowser } from '@angular/common';
import { Inject, PLATFORM_ID } from '@angular/core';
import { debounceTime, switchMap } from 'rxjs/operators';
@Component({
    selector: 'carte',
    templateUrl: 'carte.component.html',
    styleUrls: ['carte.component.scss'],
    animations: [fadeAnimation]
})
export class CarteComponent {
    @Input()
    header = 0;
    @ViewChild('basket') basket: ElementRef;
    @ViewChild('footer') footer: ElementRef;
    @ViewChild("template") template: ElementRef;
    loadProducts: boolean[] = [];
    loadMenus: boolean[] = [];
    families: any[] = [];
    menucategories: any[] = [];
    activeTab = 1;
    products: any[] = [];
    menus: any[] = [];
    familyActive = -2;
    menuCategoryActive = -2;
    idPdv: string;
    orderTypes: any[] = [];
    chosenOrderType: number;
    close: boolean = false;
    bsModalRef: BsModalRef;
    nbrOffersAuthorizedSite: number = 0;
    offerNbr: number;
    subscriptions2: Subscription[] = [];
    siteClose: boolean = false;
    siteCloseComment = "";
    loader: boolean = false;
    noProduct: boolean = false;
    anim_p: boolean = false;
    elementsN: number = 0;
    displaypanier: boolean = false;
    displayF: boolean = false;
    displayProduct: boolean = false;
    total: number = 0;
    result: boolean = false;
    idO = -1;
    loading = true;
    orderProg = null;
    address = null;
    displayBestSales = false;
    menu: boolean = false;
    @ViewChild('ordertypebar') ordertypebar: ElementRef;
    @ViewChild('btncart') btncart: ElementRef;
    @ViewChild('menufixed') menufixed: ElementRef;
    prevScrollpos = 0;
    closealert = false;
    amountMiniDelivery: number;
    amountMiniMandatory: number;
    modalRef: BsModalRef;
    scrollHandle: any = 0;
    scrollStep = 10;
    parent = null;
    dropdown = false;
    orderType=null;
    discount: number = 0;
    discountFrom: number = 0;
    @ViewChild("template2") template2;
    @HostListener('document:click', ['$event'])
    clickout(event) {
        if ((this.basket && this.footer
            && !this.basket.nativeElement.contains(event.target)
            && !this.footer.nativeElement.contains(event.target)
            && event.target.className != "flaticon-garbage"
            && event.target.classList[0] != "modal"
            && event.target.classList[0] != "modal-body"
            && event.target.className != ""
            && event.target.classList[1] != "btn-template")
            || event.target.id == "editP"
        ) {
            this.displayProduct = false;
            setTimeout(() => {
                this.displaypanier = false;
                this.displayF = false;
            }, 200)
        }
    }
    constructor(
        private familyService: FamilyService,
        private productService: ProductService,
        private menuService: MenuService,
        private orderService: OrdersService,
        private pdvService: PdvService,
        private modalService: BsModalService,
        private toastr: ToastrService,
        private router: Router,
        private route: ActivatedRoute,
        @Inject(PLATFORM_ID) private platformId: Object
    ) {}

    startScrollingEvent(direction) {
        this.startScrolling(direction)
    }

    mouseleave() {
        this.stopScrolling();
        // $(this).removeClass("active")
    }

    startScrolling(modifier) {
        if (this.scrollHandle === 0) {
            this.scrollHandle = setInterval(
                () => {
                    var newOffset = this.parent.scrollLeft + this.scrollStep * modifier;
                    this.parent.scrollLeft = newOffset;
                }, 10)
        }
    }
    stopScrolling() {
        clearInterval(this.scrollHandle);
        this.scrollHandle = 0
    }

    ngAfterViewInit() {
        this.parent = document.getElementById('tuckedMenu');
        if (this.menufixed) this.prevScrollpos = this.menufixed.nativeElement.offsetTop;
    }

    ngOnInit() {
        let sub1 = this.orderService.order.subscribe(
            (o) => {
                if (this.elementsN < o.elementsNbr) {
                    this.anim_p = true;
                }
                setTimeout(() => {
                    this.anim_p = false;
                }, 500)
                this.elementsN = o.elementsNbr;
                this.total = o.total;
            }
        )
        const subs1 = this.pdvService.pdv.subscribe(
            (data) => {
                this.siteClose = data.closeSite;
                this.siteCloseComment = data.closeComment;
                this.discount=data.discount;
                this.discountFrom=data.discountFrom;
            }
        )
        const subs2 = this.pdvService.orderTypes.subscribe((orderTypes: any[]) => {
            this.orderTypes = orderTypes;
            if (this.orderTypes.length == 0) {
                this.router.navigate(['/'])
            }
        });
        const subs8 = this.orderService.orderType.subscribe((orderType) => {
            this.orderType = orderType;
        });
        const subs3 = this.pdvService.nbrOffersAuthorizedSite.subscribe((nbrOffersAuthorizedSite: number) => {
            this.nbrOffersAuthorizedSite = nbrOffersAuthorizedSite;
        });
        const subs4 = this.orderService.offerNbr.subscribe((offerNbr: any) => {
            this.offerNbr = offerNbr;
        });
        const subs6 = this.orderService.orderProg.subscribe((orderProg) => {
            this.orderProg = orderProg;
        });
        const subs7 = this.orderService.chosenOrderType.subscribe((chosenOrderType: number) => {
            this.chosenOrderType = chosenOrderType;
            if (this.chosenOrderType > 0) {
                if (this.chosenOrderType == 1) {
                    const subs10 = this.orderService.address.subscribe((address) => {
                        if (!address) {
                            this.router.navigate(["/modes"]);
                        }
                        this.address = address;
                    });
                    this.subscriptions2.push(subs10);
                }
                this.orderType = this.chosenOrderType;
            }
            this.getElements();
        });
        const sub5 = this.orderService.amountMiniDelivery.subscribe(amountMiniDelivery => {
            this.amountMiniDelivery = amountMiniDelivery;
        });
        const sub6 = this.pdvService.pdv.subscribe((data: any) => {
            this.amountMiniMandatory = data.amountMiniMandatory;
        });
        this.subscriptions2.push(sub1, subs1, subs2, subs3, subs4, sub5, subs6, sub6, subs7, subs8);

    }
    checkoutEvent() {
        if (this.chosenOrderType == 1) {
            if (Number(this.total) >= Number(this.amountMiniDelivery)) {
                this.router.navigate(["/checkout"]);
            } else {
                if (this.amountMiniMandatory == 0) {
                    this.modalRef = this.modalService.show(this.template2, { class: 'modal-sm' });
                } else {
                    this.toastr.error('', 'Minimum de livraison: ' + this.amountMiniDelivery + ' €');
                }
            }
        } else {
            this.router.navigate(["/checkout"]);
        }
    }
    switchChose() {
        if (this.menu) {
            this.menu = false;
            this.familyActive = 0;
            this.getProducts(0);
        } else {
            this.menu = true;
            this.menuCategoryActive = 0;
            this.getMenus(0);
        }
    }
    displayP() {
        if (!this.displayProduct && this.elementsN > 0) {
            this.displaypanier = true;
            setTimeout(() => {
                this.displayF = true;
            }, 400)
            setTimeout(() => {
                this.displayProduct = true;
            }, 500)
        }
        if (this.displayProduct) {
            this.closePanier()
        }

    }

    closePanier() {
        this.displayProduct = false;
        setTimeout(() => {
            this.displaypanier = false;
            this.displayF = false;
        }, 200)
    }

    getElements() {
        Promise.all([this.getFamiliesOfCarte(), this.getMenuCategoriesOfCarte()]).then(
            () => {
                if (this.router.url.indexOf("/menu") > -1 || this.router.url.indexOf("/famille") > -1) {
                    if (this.router.url.indexOf("menu") > -1) {
                        this.route.params.subscribe(params => {
                            if (params['menu'] && this.menucategories.length > 0) {
                                this.familyActive = -2;
                                this.activeTab = 2;
                                let k = this.menucategories.findIndex(f => f.slug == params['menu']);
                                if (k > -1) {
                                    this.menu = true;
                                    this.menuCategoryActive = k;
                                    this.getMenus(this.menuCategoryActive);
                                } else {
                                    this.menu = true;
                                    this.menuCategoryActive = 0;
                                    this.getMenus(0);
                                }
                            } else {
                                this.menu = false;
                                this.familyActive = 0;
                                this.getProducts(0);
                            }
                        })
                    }
                    if (this.router.url.indexOf("famille") > -1) {
                        this.route.params.subscribe(params => {
                            if (params['family']) {
                                let k = this.families.findIndex(f => f.slug == params['family']);
                                if (k > -1) {
                                    this.menu = false;
                                    this.familyActive = k;
                                    this.getProducts(this.familyActive);
                                } else {
                                    if (k > -1) {
                                        this.menu = false;
                                        this.familyActive = 0;
                                        this.getProducts(0);
                                    }
                                }
                            }
                        })
                    }
                } else {
                    this.menu = true;
                    this.activeTab = 2;
                    this.familyActive = -2;
                    this.menuCategoryActive = 0;
                    this.getMenus(0);
                }

            }
        )
    }


    setOrderType() {
        this.route.params.subscribe(params => {
            let send = 0;
            if (this.familyActive > 0) {
                this.router.navigate(["/modes"], { queryParams: { famille: this.families[this.familyActive].slug } });
                send++;
            }
            if (send == 0 && this.menuCategoryActive > 0) {
                this.router.navigate(["/modes"], { queryParams: { menu: this.menucategories[this.menuCategoryActive].slug } });
                send++;
            }
            if (send == 0 && params['menu']) {
                this.router.navigate(["/modes"], { queryParams: { menu: params['menu'] } });
                send++;
            }
            if (send == 0 && params['family']) {
                let querparams = { famille: params['family'] }
                this.router.navigate(["/modes"], { queryParams: querparams });
                send++;
            }
            if (send == 0) {
                this.router.navigate(["/modes"]);
            }

        })
    }


    @HostListener('window:scroll', ['$event']) onScrollEvent($event) {
        if (isPlatformBrowser(this.platformId)) {
            let currentScrollPos = window.pageYOffset;
            if (this.prevScrollpos >= currentScrollPos) {
                this.ordertypebar.nativeElement.style.display = "flex";
                if (this.menufixed) this.menufixed.nativeElement.classList.remove("sticky")
            } else {
                this.ordertypebar.nativeElement.style.display = "none";
                if (this.menufixed) this.menufixed.nativeElement.classList.add("sticky")
            }
        }
    }

    PersonalizeModal(i) {
        if (this.chosenOrderType > 0) {
            let product = this.products[i];
            this.bsModalRef = this.modalService.show(PersonalizeProductComponent, { class: 'modal-content3' });
            this.bsModalRef.content.product = product;
        } else {
            this.setOrderType();
        }
    }

    OpenMenuModal(i) {
        if (this.chosenOrderType > 0) {
            if (this.menus[i].offer == null || (this.menus[i].offer != null && this.offerNbr < this.nbrOffersAuthorizedSite)) {
                this.bsModalRef = this.modalService.show(MenuModalComponent, { class: 'modal-content3 menu-modal' });
                this.bsModalRef.content.menu = this.menus[i];
            } else {
                this.toastr.error('', 'You have reached the number of authorized offers');
            }
        } else {
            this.setOrderType();
        }
    }

    getFamiliesOfCarte() {
        return this.familyService.getFamiliesOfCarte().toPromise().then(
            (families: any[]) => {
                this.families = families.sort(
                    (a, b) => {
                        if (a.order === null) {
                            return 1;
                        }
                        else if (b.order === null) {
                            return -1;
                        }
                        if (Number(a.order) > Number(b.order)) {
                            return 1;
                        }
                        if (Number(a.order) < Number(b.order)) {
                            return -1;
                        }
                        return 0;
                    }
                );
            }
        )
    }

    getMenuCategoriesOfCarte() {
        return this.familyService.getMenuCategoriesOfCarte().toPromise().then(
            (menucategories: any[]) => {
                this.menucategories = menucategories.sort(
                    (a, b) => {
                        if (a.order === null) {
                            return 1;
                        }
                        else if (b.order === null) {
                            return -1;
                        }
                        if (a.order > b.order) {
                            return 1;
                        }
                        if (a.order < b.order) {
                            return -1;
                        }
                        return 0;
                    }
                )
            }
        )
    }

    getMenus(i) {
        this.loader = true;
        this.familyActive = -2;
        this.menuCategoryActive = i;
        this.loadMenus = [];
        return this.menuService.getMenusOfCategory(this.menucategories[i].id, this.orderType, this.orderProg).toPromise().then(
            (menus: any[]) => {
                this.menus = menus;
                this.loader = false;
                this.noProduct = false;
                this.result = false;
                this.goToTopCart();
            }
        )
    }

    goToTopCart() {
        if (isPlatformBrowser(this.platformId)) {
            let element = document.getElementById('carte');
            if (element) {
                window.scroll({ top: this.offset(element).top - 75, behavior: "smooth" });
            }
        }
    }


    getProducts(i, scroll = true) {
        this.loader = true;
        this.familyActive = i;
        this.menuCategoryActive = -2;
        this.loadProducts = [];
        return this.productService.getActiveProductByFamily(this.families[i].id, this.orderType, this.orderProg).toPromise().then(
            (data: any[]) => {
                if (this.products.length > 0) {
                    this.goToTopCart();
                }
                this.products = data;
                this.loader = false;
                this.noProduct = false;
                this.result = false;
            }
        );
    }

    addElementToBasket(i) {
        if (this.chosenOrderType > 0) {
            let product = this.products[i];
            let element = {
                id: product.id,
                code: product.code,
                name: product.name,
                avatar: product.avatar,
                family: product.family,
                size: product.sizes[product.size],
                comment: '',
                qty: 1,
                removedCompositions: [],
                supplements: [],
                optionIngredients: [],
                total: 0,
                vat: product.vat,
                priceSuppApp: product.priceSuppApp,
                priceWithSupp: Number(product.sizes[product.size].price),
                maxNbrIngOptions: product.maxNbrIngOptions,
                hasSupp: product.hasSupp
            }
            element.total += Number(element.size.price);
            element.total *= Number(element.qty);
            this.orderService.addElementToOrder(element);
        } else {
            this.setOrderType();
        }
    }


    unsubscribe2() {
        this.subscriptions2.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
        this.subscriptions2 = [];
    }

    ngOnDestroy() {
        this.unsubscribe2();
    }

    offset(obj) {
        var rect = obj.getBoundingClientRect();
        var win = obj.ownerDocument.defaultView;
        return {
            top: rect.top + win.pageYOffset,
            left: rect.left + win.pageXOffset
        };
    }

    changeMode(id) {
        if (this.elementsN > 0) {
            this.idO = id;
            this.bsModalRef = this.modalService.show(this.template, {
                // class: "ordertype-modal"
            });
        } else {
            let queryParams = { ordeType: id };
            this.router.navigate(['modes'], { queryParams: queryParams })
        }
    }

    confirm() {
        this.bsModalRef.hide();
        this.orderService.clearOrder();
        setTimeout(() => {
            this.router.navigate(['/modes']);
        }, 1000)
    }


    confirm2() {
        this.modalRef.hide();
        this.router.navigate(['/checkout']);
    }

    decline() {
        this.bsModalRef.hide();
    }

    decline2() {
        this.modalRef.hide();
    }

    setActiveTab(activetab) {
        if (activetab == 1) this.getProducts(0);
        if (activetab == 2) this.getMenus(0);
        this.activeTab = activetab;
    }

}